import React from 'react'
import * as BsXLg  from "react-icons/bs";
import './Starred.css'
import { Link } from 'react-router-dom';
import str from "../../img/str.svg";
const Starred = ({setSterreedCont}) => {
  return (
    <div>
         <div className="modalBackground">
      <div className="modalContaineresbbb">
       
            <div className = 'acuntdivesbbb'> Starred 
          

       
        <Link className="iconcolorchngees" >
            <BsXLg.BsXLg onClick={()=>setSterreedCont(false)} />
          </Link>
          </div>
         
        <hr  className='linedivmrgn'style={{width:"260px", border:'1px solid darkgray'}}/>
      
      <div>
        <img src={str} className = 'divrightes'/>
      </div>
      <div style={{color:'black',marginTop:'10px'}}>
        <p>Star important boards to access them quickly and easily.</p>
      </div>


      
      </div>
    </div>
    </div>
  )
}

export default Starred